import { DateTimeFormat } from '@billy/design-system'
import { Text, View } from '@react-pdf/renderer'

import { commonPdfTableStyles } from '@features/exports/utils/commonTableStyles'
import { sanitizeCurrencyForPdf } from '@features/exports/utils/sanitizeCurrencyForPdf'

import { getCurrentLocale } from '../../../../../../../../../../../../utils'
import type { AuditTrailAccountTable } from '../../../../types/AuditTrail'
import { AuditTrailColumnStyles } from '../styles/AuditTrailColumnStyles'

interface AuditTrailTableBodyProps {
  index: number
  line: AuditTrailAccountTable
}

export const AuditTrailTableBody = ({ line, index }: AuditTrailTableBodyProps) => {
  const { cellTransaction, cellDate, cellVoucher, cellDescription, bodyText } = AuditTrailColumnStyles
  const { wrapper, cell, cellRight, row } = commonPdfTableStyles

  const isAccountType = line.type === 'account'
  const locale = getCurrentLocale()

  return (
    <View style={wrapper}>
      {(line?.mainData ?? []).map((subItem, subIndex) => {
        const {
          amount: amountData,
          balance: balanceData,
          date,
          description,
          netAmount,
          rate,
          transaction,
          voucher,
        } = subItem

        const net = sanitizeCurrencyForPdf(netAmount || '')
        const amount = sanitizeCurrencyForPdf(amountData || '')
        const balance = sanitizeCurrencyForPdf(balanceData || '')

        return (
          <View key={`${index}-${subIndex}`} style={row} wrap={false}>
            <View style={cellTransaction}>
              <Text style={bodyText}>{transaction || ''}</Text>
            </View>
            <View style={cellDate}>
              <Text style={bodyText}>{date ? DateTimeFormat.getFormattedDate(date, locale) : ''}</Text>
            </View>
            <View style={cellVoucher}>
              <Text style={bodyText}>{voucher || ''}</Text>
            </View>
            <View style={[cell, cellDescription]}>
              <Text style={bodyText}>{description || ''}</Text>
            </View>
            {isAccountType && (
              <View style={[cell, cellRight]}>
                <Text style={bodyText}>{net || ''}</Text>
              </View>
            )}
            {isAccountType && (
              <View style={[cell, cellRight]}>
                <Text style={bodyText}>{rate || ''}</Text>
              </View>
            )}
            <View style={[cell, cellRight]}>
              <Text style={bodyText}>{amount || ''}</Text>
            </View>
            <View style={[cell, cellRight]}>
              <Text style={bodyText}>{balance || ''}</Text>
            </View>
          </View>
        )
      })}
    </View>
  )
}
